export default __webpack_public_path__ + "static/media/pincho-hombre-rubio.3e1040d7.png";